// Milestone日期状态
export enum MilestoneDateStatus {
  // 已定
  Confirm = 1,
  // 待定，简称TBC
  ToBeConfirm = 2,
}
